import Link from 'next/link';

import { cn } from '@kit/ui/utils';

/**
 * Selenos Logo
 * Geometric wordmark with pipeline accent dot in emerald green
 */
export function LogoImage({
  className,
}: {
  className?: string;
  width?: number;
}) {
  return (
    <span
      className={cn(
        'text-foreground inline-flex items-baseline text-xl font-semibold tracking-tight lg:text-2xl',
        className,
      )}
      style={{ fontFamily: "'Space Grotesk', 'Inter', system-ui, sans-serif" }}
    >
      selenos
      <span className="bg-primary mb-[0.15em] ml-[0.15em] inline-block h-[0.3em] w-[0.3em] rounded-full" />
    </span>
  );
}

export function AppLogo({
  href,
  label,
  className,
}: {
  href?: string | null;
  className?: string;
  label?: string;
}) {
  if (href === null) {
    return <LogoImage className={className} />;
  }

  return (
    <Link
      aria-label={label ?? 'Home Page'}
      href={href ?? '/'}
      prefetch={true}
      className="mx-auto md:mx-0"
    >
      <LogoImage className={className} />
    </Link>
  );
}
